export const commonAssessmentKitConstants = {
    //login
    INVITE_CANDIDATE_TO_ASSESSMENT_ACTION_REQUEST: "INVITE_CANDIDATE_TO_ASSESSMENT_ACTION_REQUEST",
    INVITE_CANDIDATE_TO_ASSESSMENT_ACTION_SUCCESS: "INVITE_CANDIDATE_TO_ASSESSMENT_ACTION_SUCCESS",
    INVITE_CANDIDATE_TO_ASSESSMENT_ACTION_FAILURE: "INVITE_CANDIDATE_TO_ASSESSMENT_ACTION_FAILURE",

    INVITED_ASSESSMENT_KITS_CANDIDATE_ACTION_REQUEST: "INVITED_ASSESSMENT_KITS_CANDIDATE_ACTION_REQUEST",
    INVITED_ASSESSMENT_KITS_CANDIDATE_ACTION_SUCCESS: "INVITED_ASSESSMENT_KITS_CANDIDATE_ACTION_SUCCESS",
    INVITED_ASSESSMENT_KITS_CANDIDATE_ACTION_FAILURE: "INVITED_ASSESSMENT_KITS_CANDIDATE_ACTION_FAILURE",
  };